import { IKostenermittlungsart } from "./IKostenermittlungsart";

export class Kostenermittlungsart implements IKostenermittlungsart {
    kostenermittlungsartID: number;
    kostenermittlung: string;
    beschreibung: string;
    varianz: number;
    sort: number;
    get anzeige(): string {
        return `${this.kostenermittlung} (${this.varianz * 100}%)`;
    } 

    constructor(
        kostenermittlungsartID: number,
        kostenermittlung: string,
        beschreibung: string,
        varianz: number,
        sort: number
    ) {
        this.kostenermittlungsartID = kostenermittlungsartID;
        this.kostenermittlung = kostenermittlung;
        this.beschreibung = beschreibung;
        this.varianz = varianz;
        this.sort = sort;
    }
}
